<template>
  <div class="textProof" v-show="!formItemInfo.needHide">
    <header class="proof-title">
      {{formItemInfo.name}}
    </header>
    <div class="proof-desc">
      {{formItemInfo.desc}}
    </div>
    <z-field
      class="proof-input"
      v-model="inputVal"
      type="textarea"
      autosize
      @input="onInputChange"
      count-word
      :maxlength="maxTextCount"
      rows="1"
    />
  </div>
</template>

<script>
import { Field } from '@zz-common/zz-ui'
import { getRuleValue, showRuleTips } from '../utils'

export default {
  name: 'TextProof',
  data() {
    return {
      inputVal: ''
    }
  },
  props: {
    formItemInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    isRequire() {
      const { rules } = this.formItemInfo || {}
      return Boolean(Number(getRuleValue(rules, 'isRequire')))
    },
    maxTextCount() {
      const { rules } = this.formItemInfo
      return Number(getRuleValue(rules, 'maxTextCount')) || 100 // 默认最大为100个
    }
  },
  components: {
    zField: Field
  },
  methods: {
    customValidate() {
      let validation = true
      const { rules } = this.formItemInfo
      if (this.isRequire && this.inputVal.length === 0) {
        showRuleTips(rules, 'isRequire')
        validation = false
      }
      return validation
    },
    onInputChange() {
      const { type, name } = this.formItemInfo
      this.$emit('onSubmit', { type, name, value: this.inputVal })
    }
  }
}

</script>
<style lang="less">
  @import 'index.less';
</style>